import React from 'react';
import Typography from '@mui/material/Typography';

export default function Error() {
  return (
    <div>
      <Typography variant="body2" sx={{ mb: 1 }}>Failed to retrieve data</Typography>
    </div>
  )
};
